import comp from "./NameModal";
export default comp;
